const RELOAD_ATTEMPT_KEY = "nijiurachan-chunk-reload";

/**
 * deploy直後に開いたままのセッションを、1度だけ自動で復旧させる。
 *
 * 配信は世代を残さず入れ替わるため、deployをまたいだセッションが遅延chunkを
 * 取得しようとすると404になる。Viteはこのとき `vite:preloadError` を投げるが、
 * 受け手が無いと例外がそのまま上がり、利用者は手動リロードしか手段が無い。
 *
 * リロードすればHTMLごと新しい世代へ揃うので、ここで1度だけ試す。
 * 2度目以降は無限リロードを避けて何もせず、ErrorBoundaryの再読み込み導線へ委ねる。
 * 成功した起動で印を消すため、次のdeployでも同じ1回分が使える。
 */
export function registerChunkReloadGuard(
  target: EventTarget = globalThis.window,
  storage: Storage | undefined = safeSessionStorage(),
  reload: () => void = () => {
    globalThis.location.reload();
  },
): void {
  target.addEventListener("vite:preloadError", (event: Event) => {
    if (readItem(storage, RELOAD_ATTEMPT_KEY) !== null) {
      return;
    }
    writeItem(storage, RELOAD_ATTEMPT_KEY, "1");
    // リロードで復旧させるので、既定の再throwは止める。
    event.preventDefault();
    reload();
  });
}

/** 起動できた時点で印を消し、次のdeployでも自動復旧を1回使えるようにする。 */
export function clearChunkReloadGuard(
  storage: Storage | undefined = safeSessionStorage(),
): void {
  try {
    storage?.removeItem(RELOAD_ATTEMPT_KEY);
  } catch {
    // storageが使えない環境では自動復旧を諦める。表示自体は妨げない。
  }
}

function safeSessionStorage(): Storage | undefined {
  try {
    return globalThis.sessionStorage;
  } catch {
    return undefined;
  }
}

function readItem(storage: Storage | undefined, key: string): string | null {
  try {
    return storage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

function writeItem(
  storage: Storage | undefined,
  key: string,
  value: string,
): void {
  try {
    storage?.setItem(key, value);
  } catch {
    // 書けない場合は印を残せないだけで、リロード自体は試す価値がある。
  }
}
